<!--NAV BAR-->
<app-navbar>
</app-navbar>
<div class="store-page-overlay"></div>

<div class="container-fluid">
  <div class="row row-sm-offset">

    <div class="col-md-12">
      <div class="store-content">
        <div class="store-inner">
          <h4 class="checkout-heading">
            Dashboard
          </h4>
          <p class="checkout-sub-heading">Search</p>

        </div>

        <div style="margin-right:15px;margin-left:5px" class="row">
          <div class="form-group input-lg col-md-12">
            <label class="d-block">
              <label for="search" class="input-label">* Enter your search query below</label>
              <input id="search" (keyup.enter)="executeSearchQuery()" [value]="searchInput"
                (input)="searchInput = $event.target.value" type="text"
                placeholder="Search for pharmacies or endpoints or namespaces" />
              <label [ngClass]="isSearchEntered ? '' : 'active'" class="error">Search query must be entered.</label>
              <span [ngClass]="isSearchEntered ? '' : 'input-group-icon-validation-offset'"
                class="input-group-icon input-group-icon-adjusted-margin float-right">
                <i class="fas fa-search" (click)="executeSearchQuery()"></i>
              </span>
            </label>
          </div>
        </div>
      </div>

      <div *ngIf="isInSearchView" class="row mt-3">
        <div class="col-md-12 mb-3 text-right">
          <button (click)="closeSearch()" class="btn btn-secondary"><i class="fa fa-times"></i> Close Search</button>
        </div>
        <ng-container *ngFor="let searchResult of searchResults">

          <div class="col-md-6 mb-3">

            <div class="summary-card p-3">
              <div class="summary">
                <table class="tbl-search">
                  <tr>
                    <td>
                      <h6>
                        {{searchResult.ResultField}}
                        <span class="badge badge-secondary">
                          {{typeConversion(searchResult.TableEnum)}}
                        </span>
                      </h6>
                      <div *ngIf="searchResult.TableEnum==0">

                        <table class="tbl-search">
                          <tbody>
                            <tr>
                              <th scope="col" class="fixed-td-width-sm">
                                Type
                              </th>
                              <td>
                                Pharmacy
                              </td>
                            </tr>
                            <tr>
                              <th scope="col" class="fixed-td-width-sm">
                                NPI
                              </th>
                              <td>
                                {{searchResult.NPI}}
                              </td>
                            </tr>
                            <tr>
                              <th scope="col" class="fixed-td-width-sm">
                                Address
                              </th>
                              <td>
                                {{searchResult.StreetAddress}} {{searchResult.City}} {{searchResult.ZIPCode}}
                                {{searchResult.State}}
                              </td>
                            </tr>
                          </tbody>
                        </table>

                      </div>
                    </td>
                    <td class="td-chev">
                      <div class="right-chev">
                        <i *ngIf="searchResult.TableEnum == 1" (click)="goToAzureAccount(searchResult.Id)"
                          class="fal fa-angle-right"></i>
                        <i *ngIf="searchResult.TableEnum == 3" (click)="goToAzureNamespace(searchResult.Id)"
                          class="fal fa-angle-right"></i>
                        <i *ngIf="searchResult.TableEnum == 2" (click)="goToAzureEndpoints(searchResult.Id)"
                          class="fal fa-angle-right"></i>
                      </div>
                    </td>
                  </tr>
                </table>

              </div>
            </div>
          </div>
        </ng-container>

      </div>

      <div *ngIf="!isInSearchView" class="row mt-3">

        <div class="col-md-6 mb-3">
          <div class="summary-card">
            <table style="width:100%">
              <tr>
                <td class="summary-icon-wrapper">
                  <i class="fad fa-clinic-medical summary-icon"></i>
                </td>
                <td class="summary">
                  <p>
                    Total Pharmacies
                  </p>
                  <div class="div-num">
                    {{statistics.TotalPharmacies}}
                  </div>

                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <div class="summary-card">
            <table style="width:100%">
              <tr>
                <td class="summary-icon-wrapper">
                  <i class="fad fa-link summary-icon"></i>
                </td>
                <td class="summary">
                  <p>
                    Total Pharmacies (with Relay enabled)
                  </p>
                  <div class="div-num">
                    {{statistics.PharmaciesWithRelayEnabled}}
                  </div>

                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <div class="summary-card">
            <table style="width:100%">
              <tr>
                <td class="summary-icon-wrapper">
                  <i class="fad fa-ban summary-icon"></i>
                </td>
                <td class="summary">
                  <p>
                    Total Pharmacies (which canceled Relay)
                  </p>
                  <div class="div-num">
                    {{statistics.PharmaciesStoppedUsingRelay}}
                  </div>

                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <div class="summary-card">
            <table style="width:100%">
              <tr>
                <td class="summary-icon-wrapper">
                  <i class="fad fa-signal-stream summary-icon"></i>
                </td>
                <td class="summary">
                  <p>
                    Total Pharmacies (with SignalR enabled)
                  </p>
                  <div class="div-num">
                    {{statistics.PharmaciesWithSignalREnabled}}
                  </div>

                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <div class="summary-card">
            <table style="width:100%">
              <tr>
                <td class="summary-icon-wrapper">
                  <i class="fad fa-browser summary-icon"></i>
                </td>
                <td class="summary">
                  <p>
                    Total Pharmacies (with Web API enabled)
                  </p>
                  <div class="div-num">
                    {{statistics.PharmaciesWithWebAPIEnabled}}
                  </div>

                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <div class="summary-card">
            <table style="width:100%">
              <tr>
                <td class="summary-icon-wrapper">
                  <i class="fad fa-ball-pile summary-icon"></i>
                </td>
                <td class="summary">
                  <p>
                    Total Pharmacies Group
                  </p>
                  <div class="div-num">
                    {{statistics.PharmaciesGroups}}
                  </div>

                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <div class="summary-card">
            <table style="width:100%">
              <tr>
                <td class="summary-icon-wrapper">
                  <i class="fad fa-puzzle-piece summary-icon"></i>
                </td>
                <td class="summary">
                  <p>
                    Total Namespaces
                  </p>
                  <div class="div-num">
                    {{statistics.NamespacesInUse}}
                  </div>

                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <div class="summary-card">
            <table style="width:100%">
              <tr>
                <td class="summary-icon-wrapper">
                  <i class="fad fa-globe summary-icon"></i>
                </td>
                <td class="summary">
                  <p>
                    Total Endpoints
                  </p>
                  <div class="div-num">
                    {{statistics.EndpointsInUse}}
                  </div>

                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <div class="summary-card">
            <table style="width:100%">
              <tr>
                <td class="summary-icon-wrapper">
                  <i class="fad fa-user-friends summary-icon"></i>
                </td>
                <td class="summary">
                  <p>
                    Total Azure Accounts
                  </p>
                  <div class="div-num">
                    {{statistics.AzureAccountsInUse}}
                  </div>

                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div (click)="logout()" class="log-out">
        <i class="fas fa-sign-out-alt"></i>Log out
      </div>
    </div>

    <!-- <div class="col-md-3-5">
            <div class="delivery-content">
                <ul class="ypw-tab">
                    <li (click)="onTabClicked(0)" class='{{ firstTabClass }}'>
                        Option 1
                    </li>
                    <li (click)="onTabClicked(1)" class='{{ lastTabClass }}'>
                        Option 2
                    </li>
                </ul>

                <div class="delivery-content-inner">
                    <p>blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah</p>
                    <p>blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah</p>
                    <p>blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah</p>
                    <p>blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah</p>
                    <p>blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah blah</p>


                </div>
            </div>
        </div> -->

  </div>
</div>

<app-powered-by></app-powered-by>
